import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import {
  getEncounterDiagnosis,
  saveEncounterDiagnosis,
} from "app/services/EncounterService";
import {
  getImageVisitEncounterById,
  voidFileVisit,
} from "app/services/VisitService";
import { getFileById } from "app/services/FileDescriptionExtService";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingCheckIn } from "app/services/ReceptionService";

export default class EncounterDiagnosisStore {
  selectEncounterDiagnosis = null;
  selectedVisitImage = null;
  selectedCheckin = null;
  previewImages = [];
  openConfirmDeleteSingleImage = null;
  searchCheckIn = {
    ...new SearchObject(),
    fromDate: null,
    toDate: null,
    departmentId: null,
  };
  pageCheckIn = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedCheckIn = (checkin) => {
    this.selectedCheckin = checkin;
  };

  handleGetEncounterDiagnosis = async ({ patientId, visitId, encounterDatetime }) => {
    if (!patientId || !visitId) {
      return;
    }

    try {
      const { data } = await getEncounterDiagnosis({ patientId, visitId });

      this.handleGetImageVisitEncounterById(visitId);

      // Nếu API không trả về data -> tạo mới luôn tại đây
      this.selectEncounterDiagnosis = data?.id
        ? {
          ...data,
          encounterDatetime: encounterDatetime,
        }
        : {
          patientId,
          practitioner: null,
          note: "",
          encounterDatetime: encounterDatetime,
          listObsDto: [],
        };
      console.log("selectEncounterDiagnosis", encounterDatetime)
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
      // fallback để form vẫn chạy
      this.selectEncounterDiagnosis = {
        patientId,
        practitioner: null,
        note: "",
        encounterDatetime: encounterDatetime,
        listObsDto: [],
      };
    }
  };


  handleGetImageVisitEncounterById = async (visitId) => {
    try {
      const res = await getImageVisitEncounterById(visitId);
      if (res?.data?.fileDescriptions?.length > 0) {
        const previewImages = await Promise.all(
          res?.data?.fileDescriptions?.map(async (img) => {
            const blob = await getFileById(img?.id);
            const url = URL.createObjectURL(blob?.data);
            return { ...img, url };
          })
        );
        this.previewImages = previewImages;
      } else {
        this.previewImages = [];
      }
      this.selectedVisitImage = res?.data;
    } catch (error) {
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  setPreviewImages = (images) => {
    this.previewImages = images;
  };

  handleSaveEncounterDiagnosis = async (encounterDiagnosis) => {
    try {
      const { data } = await saveEncounterDiagnosis(encounterDiagnosis);
      toast.success("Cập nhật kết quả điều trị thành công");
      this.selectEncounterDiagnosis = data;
      return data;
    } catch (error) {
      console.error(error);
      toast.error("Lưu dữ liệu có lỗi");
      throw error;
    }
  };

  handleChangeFormSearch = (searchCheckIn) => {
    this.searchCheckIn = { ...this.searchCheckIn, ...searchCheckIn };
    this.pagingCheckIn();
  };

  pagingCheckIn = async () => {
    let { departmentId, ...ortherData } = this.searchCheckIn;

    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }

    return await pagingCheckIn({ ...ortherData })
      .then(({ data }) => {
        this.pageCheckIn = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu check in khách hàng có lỗi");
      });
  };

  handleDeletSingleImage = (id) => {
    this.openConfirmDeleteSingleImage = id;
  };
  handleCloseConfirmSingleImage = () => {
    this.openConfirmDeleteSingleImage = null;
  };

  handleDeleteSingleImage = async () => {
    try {
      const { data } = await voidFileVisit(this.openConfirmDeleteSingleImage);
      if (data) {
        toast.success(`Xóa dữ liệu ảnh thành công!`);
        this.handleGetImageVisitEncounterById(this.selectedCheckin?.visitId);
      } else {
        toast.error(`Xóa dữ liệu ảnh có lỗi!`);
      }
      this.openConfirmDeleteSingleImage = null;
    } catch (error) {
      console.error(error);
      toast.error(`Xóa dữ liệu ảnh có lỗi!`);
    }
  };

  resetStore = () => {
    this.selectEncounterDiagnosis = null;
    this.previewImages = [];
    this.selectedCheckin = null;
    this.pageCheckIn = new PageResponse();
  };
}
